import { gql } from "@apollo/client"

export const GET_USER_LIST = gql`
query GetUsers($pageOptions: PageOptions, $filters: [UsersFilters], $sortOptions: [SortOptions]) {
  getUsers(pageOptions: $pageOptions, filters: $filters, sortOptions: $sortOptions) {
    totalCount
    users {
      id
      username
      email
      password_hash
      user_type
      type_code
      status_code
      first_name
      last_name
      created_date
      modified_date
    }
  }
}
`;


export const GET_USER_BY_EMAIL_ID = gql`
query GetUser($getUserId: ID, $email: String) {
  getUser(id: $getUserId, email: $email) {
    id
    username
    email
    password_hash
    user_type
    type_code
    status_code
    first_name
    last_name
    created_date
    modified_date
  }
}
`